export default __webpack_public_path__ + "static/slider4-ffbff0120a0450bcc36808b922d825d5.png";